<template>
  <div class="money-container">
    <div class="section">
      <div class="money-title">我的消费金</div>
      <div class="break-line" />
      <div class="money-view">
        <div class="title">今日消费金</div>
        <div class="break-row" />
        <span class="money">{{ (todayMoney+coffeeGold.todayCost).toFixed(2) }}</span>
      </div>
      <div class="money-view money-now-month">
        <div class="left">
          <div class="title">本月消费金</div>
          <div class="break-row" />
          <span class="money">{{ (monthMoney+coffeeGold.monthCost).toFixed(2) }}</span>
        </div>
        <!-- <div class="arrow-icon"></div> -->
      </div>
    </div>
    <div class="line"></div>
    <Tabs
      default-active-key="1"
      @change="callback"
      class="tabs"
      animated="false"
    >
      <TabPane key="1" tab="历史菜金" force-render>
        <div
          class="section histroy-section"
          v-if="beforeMonthMoneyArr.length !== 0"
        >
          <div class="histroy-header">
            <div class="money-title">历史菜金</div>
            <div class="tips" v-show="!isShow" @click="showInfo(true)">
              展开明细
              <span class="icon down-icon"></span>
            </div>
            <div class="tips" v-show="isShow" @click="showInfo(false)">
              收起明细
              <span class="icon up-icon"></span>
            </div>
          </div>
          <div class="auto-container">
            <div class="month-money-list-item">
              <div
                :class="{ active: !$store.state.user.is_feedback }"
                class="text-view"
              >
                <span class="time">{{ beforeMonthMoneyArr[0].date }}菜金</span>
                <span class="dash">{{ beforeMonthMoneyArr[0].price }}</span>
              </div>
            </div>
            <div class="detail-container" v-show="isShow">
              <div class="row header">
                <span class="time">订单时间</span>
                <span class="price">价格</span>
              </div>
              <div class="row" v-for="(item, index) in details" :key="index">
                <span class="time"
                  >{{ formatTime(item.select_date) }} {{ item.select_week_day }}
                  <i
                    v-if="item.order_notice.length > 0"
                    @click="clickTip(index)"
                  >
                    <div class="rect" v-show="showTip === `item${index}`">
                      <div class="notice-container">
                        <p v-for="notice in item.order_notice" :key="notice">
                          {{ notice }}
                        </p>
                      </div>
                    </div>
                  </i>
                </span>
                <span class="price">{{ item.daily_price }}</span>
              </div>
            </div>
            <div
              v-for="(item, index) in beforeMonthMoneyArr"
              :key="index"
              class="month-money-list-item"
              v-show="index !== 0"
            >
              <div class="text-view">
                <span class="time">{{ item.date }}菜金</span>
                <span class="dash">{{ item.price }}</span>
              </div>
            </div>
          </div>
        </div>
      </TabPane>
      <TabPane key="2" tab="历史咖啡金" force-render>
        <CoffeeGold :detailGold="detailGold" :coffeeGold="coffeeGold" />
      </TabPane>
    </Tabs>
    <div
      class="btn-group"
      v-if="!$store.state.user.is_feedback && beforeMonthMoneyArr.length !== 0"
    >
      <span class="tips"
        >{{ beforeMonthMoneyArr[0]["date"] }}消费金是否有误？</span
      >
      <div class="btn-group-area">
        <router-link tag="div" to="/p/user/money/feedback" class="error-btn"
          >消费金错误</router-link
        >
        <div @click="confirmMoney" class="confirm-btn">确认无误</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "ant-design-vue";
import "ant-design-vue/lib/tabs/style/css";
const { TabPane } = Tabs;
import CoffeeGold from "@/components/coffee/CoffeeGold.vue";

export default {
  name: "Money",
  components: {
    Tabs,
    TabPane,
    CoffeeGold
  },
  data() {
    return {
      todayMoney: "",
      monthMoney: "",
      beforeMonthMoneyArr: [],
      isShow: false,
      details: [],
      showTip: "",
       // 咖啡金
      detailGold: [],
      coffeeGold: {
        history: []
      }
    };
  },
  created() {
    this.$nextTick(() => {
      // 请求菜金数据
      this.APIS.REQUEST_MEAL_MONEY(this.$store.state.user_info.id)
        .then((res) => {
          if (res.data.status === 0) {
            this.todayMoney = res.data.prices[0].price;
            this.monthMoney = res.data.prices[1].price;
            this.beforeMonthMoneyArr = res.data.prices.slice(2);
            this.getOrders();
          }
        })
        .catch((err) => {
          this.$store.commit("show_alert", "登陆超时，请重新登录");
          // 跳转到登陆界面
          this.$router.push("/p/login");
          console.log(err);
        });
    });
        this.getGoldList()
    this.getMyDrinkCost()
  },
  methods: {
        // 获取上个月咖啡金明细
    getGoldList () {
      this.axios
        .get('/drinks/customer/getMyDrinkCostDetail')
        .then((res) => {
          if (res.code === 0) {
            this.detailGold = res.data.result
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$message.error('获取咖啡明细失败！')
        })
    },
    // 获取获取咖啡金统计
    getMyDrinkCost () {
      this.axios
        .get('/drinks/customer/getMyDrinkCost')
        .then((res) => {
          if (res.code === 0) {
            this.coffeeGold = res.data.result
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$message.error('获取咖啡金统计失败！')
        })
    },
      callback(key) {
      console.log(key);
    },
    //获取咖啡金额

    confirmMoney() {
      this.APIS.CONFIRM_MONEY().then((res) => {
        if (res.data.status === 0) {
          this.$store.commit("set_is_feedback", 1);
          this.$store.commit("show_alert", "提交成功");
        } else {
          this.$store.commit("show_alert", "提交有误");
        }
      });
    },
    showInfo(status) {
      this.isShow = status;
    },
    async getOrders() {
      this.requesting = true;
      let params = {
        user_id: this.$store.state.user_info.id,
        cmd: 4,
        log_month: this.beforeMonthMoneyArr[0]["date"],
        // log_month: '2019-03'
      };
      // 请求订单数据
      this.APIS.REQUEST_ORDERS(params)
        .then((res) => {
          if (res.data.status === 0 && res.data.daily_data.length > 0) {
            this.details = res.data.daily_data;
          }
        })
        .catch((e) => {
          this.$store.commit("show_alert", "登陆超时，请重新登录");
          // 跳转到登陆界面
          this.$router.push("/p/login");
        });
    },
    formatTime(time) {
      return time.replace(/^.{5}/, "").split("-").join("/");
    },
    clickTip(index) {
      if (this.showTip === `item${index}`) {
        this.showTip = "";
      } else {
        this.showTip = `item${index}`;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.money-container {
  width: 900px;
  display: flex;
  flex-direction: column;
  position: relative;
  .money-title {
    font-size: 20px;
    color: #333333;
    margin-top: 30px;
  }
  .break-line {
    width: 100%;
    margin-top: 20px;
    border-bottom: 1px solid #e0e0e0;
  }
  .money-view {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;
    &.money-now-month {
      justify-content: space-between;
      .left {
        display: flex;
      }
    }
    .title {
      width: 90px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ff9a28;
      border-radius: 15px;
      font-size: 16px;
      color: #ffffff;
    }
    .break-row {
      width: 1px;
      height: 34px;
      margin-left: 30px;
      margin-right: 30px;
      background-color: #e0e0e0;
    }
    .money {
      font-size: 24px;
      color: #333333;
    }
    .arrow-icon {
      width: 6px;
      height: 10px;
      background-image: url("../../../static/img/user/icon_next.png");
    }
  }
  .month-money-list-item {
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin-top: 20px;
    .text-view {
      width: 900px;
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f5f5f5;
      border-radius: 6px;
      color: #999;
      &.active {
        color: #fff;
        background: #ff9a28;
      }
      .time {
        font-size: 20px;
        margin-left: 24px;
      }
      .dash {
        font-size: 24px;
        margin-right: 20px;
      }
    }
  }
  .btn-group {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 960px;
    height: 82px;
    background: #fff;
    border: 1px solid #e5e5e5;
    border-bottom: none;
    box-sizing: border-box;
    padding: 0 30px;
    .tips {
    }
    .btn-group-area {
      display: flex;
      justify-content: space-between;
      width: 282px;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 126px;
        height: 42px;
        border-radius: 21px;
      }
      .error-btn {
        border: 1px solid #ff9a28;
        color: #ff9a28;
        cursor: pointer;
      }
      .confirm-btn {
        background: #ff9a28;
        color: #fff;
        cursor: pointer;
      }
    }
  }
  .line {
    position: absolute;
    left: -30px;
    top: 274px;
    width: 960px;
    background: #f5f5f5;
    height: 10px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    box-sizing: border-box;
  }
  .section {
    box-sizing: border-box;
    &:nth-child(1) {
      margin-bottom: 10px;
    }
    .histroy-header {
      display: flex;
      height: 70px;
      line-height: 22px;
      border-bottom: 1px solid #e0e0e0;
      justify-content: space-between;
      .tips {
        display: flex;
        align-items: center;
        color: #ff9a28;
        font-size: 16px;
        cursor: pointer;
        .icon {
          width: 14px;
          height: 8px;
          margin-left: 5px;
        }
        .down-icon {
          background-image: url("../../../static/img/user/icon_down.png");
        }
        .up-icon {
          background-image: url("../../../static/img/user/icon_up.png");
        }
      }
    }
  }
  .detail-container {
    .row {
      display: flex;
      color: #666;
      font-size: 16px;
      border-bottom: 1px solid #e0e0e0;
      justify-content: space-between;
      height: 51px;
      align-items: center;
      .time {
        display: flex;
        align-items: center;
        width: 198px;
        margin-left: 10px;
        i {
          display: inline-block;
          position: relative;
          margin-left: 9px;
          width: 18px;
          height: 18px;
          background-image: url("../../../static/img/user/icon_notice.png");
          .rect {
            position: absolute;
            top: 20px;
            left: 4px;
            width: 0;
            height: 0;
            // border-left: 5px solid transparent;
            // border-right: 5px solid transparent;
            // border-bottom: 8px solid #e9e9e9;
            .notice-container {
              position: absolute;
              top: 8px;
              left: -50px;
              background: #fff;
              min-width: 400px;
              border-radius: 5px;
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
              color: #333;
              font-size: 14px;
              line-height: 17px;
              p {
                margin-left: 16px;
                font-style: normal;
              }
            }
          }
        }
      }
      .price {
        width: 52px;
        margin-right: 10px;
      }
    }
    .header {
      height: 32px;
      color: #999;
      margin-top: 16px;
    }
  }
  .histroy-section {
    height: calc(100% - 290px);
  }
  .auto-container {
    overflow-y: scroll;
    // width: calc(100% + 10px);
    // padding-right: 10px;
    max-height: 700px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/money.vue